export const FPS = 30;
export const VIDEO_WIDTH = 1920;
export const VIDEO_HEIGHT = 1080;

// Video comercial ~90s — narrativa landing, voz 1.3x
// Audio @1.3x: problem=12.04, hero=4.39, features=8.44, ai=11.18,
// analytics=13.98, monitor=12.17, integrations=7.37, cta=2.35
export const SCENES = {
  INTRO: { from: 0, duration: 75 }, // 2.5s
  PROBLEM: { from: 75, duration: 395 }, // 13.2s (audio 12.04s)
  HERO: { from: 470, duration: 160 }, // 5.3s  (audio 4.39s)
  FEATURES: { from: 630, duration: 290 }, // 9.7s  (audio 8.44s)
  AI: { from: 920, duration: 370 }, // 12.3s (audio 11.18s)
  ANALYTICS: { from: 1290, duration: 455 }, // 15.2s (audio 13.98s)
  MONITOR: { from: 1745, duration: 400 }, // 13.3s (audio 12.17s)
  INTEGRATIONS: { from: 2145, duration: 255 }, // 8.5s  (audio 7.37s)
  CTA: { from: 2400, duration: 120 }, // 4s    (audio 2.35s)
  OUTRO: { from: 2520, duration: 75 }, // 2.5s
} as const;

export const TOTAL_DURATION = 2595; // ~86.5s

export const COLORS = {
  bg: '#F8FAFC',
  bgLight: '#FFFFFF',
  primary: '#3B82F6',
  primaryLight: '#2563EB',
  violet: '#7C3AED',
  cyan: '#0891B2',
  emerald: '#059669',
  amber: '#D97706',
  red: '#DC2626',
  white: '#0F172A', // dark text on light bg
  gray: '#64748B',
  grayDark: '#94A3B8',
  brandIndigo: '#5F21B5',
  brandTeal: '#9B2A7A',
  brandAmber: '#D9580B',
  gradientBlue: 'linear-gradient(135deg, #3730A3, #0D9488)',
  gradientCyan: 'linear-gradient(135deg, #0D9488, #3B82F6)',
  gradientViolet: 'linear-gradient(135deg, #3730A3, #8B5CF6)',
  gradientBrand: 'linear-gradient(135deg, #5F21B5, #9B2A7A, #D9580B)',
};

// Subtítulos — narrativa de landing
export const SUBS = {
  PROBLEM: [
    { text: 'Tu equipo cotiza en Excel. Pierde horas. Se equivoca.', from: 10, to: 150 },
    { text: 'Tu competencia cambia precios a diario.', from: 160, to: 250 },
    { text: 'Tus costos de importación? Una caja negra.', from: 260, to: 370 },
  ],
  HERO: [{ text: 'Dejá de perder ventas. Cotizá rápido y con precisión.', from: 10, to: 140 }],
  FEATURES: [
    { text: 'Cotizaciones profesionales en minutos. 16 modelos de pricing.', from: 10, to: 150 },
    { text: 'Aprobaciones automáticas. Todo en una plataforma.', from: 160, to: 270 },
  ],
  AI: [
    { text: 'IA que predice qué cotizaciones vas a ganar.', from: 10, to: 170 },
    { text: 'Un estratega de pricing que nunca duerme.', from: 180, to: 340 },
  ],
  ANALYTICS: [
    { text: 'Revenue, márgenes, win rate, tendencias por vendedor.', from: 10, to: 210 },
    { text: 'Deja de adivinar. Empieza a decidir.', from: 220, to: 420 },
  ],
  MONITOR: [
    { text: 'Competidores monitoreados 24/7. Alertas automáticas.', from: 10, to: 190 },
    { text: 'Costos de importación rastreados al centavo.', from: 200, to: 375 },
  ],
  INTEGRATIONS: [{ text: 'SAP, Salesforce, Odoo. En minutos, no en meses.', from: 10, to: 230 }],
  CTA: [{ text: 'Dejá de perder ventas. Agenda tu demo ahora.', from: 5, to: 100 }],
};

export const FEATURES_LIST = [
  { icon: '📋', title: 'Cotizaciones', desc: 'Multi-sección, cálculo automático' },
  { icon: '🧮', title: '16+ Modelos', desc: 'Fórmulas dinámicas' },
  { icon: '✅', title: 'Aprobaciones', desc: 'Workflows automáticos' },
  { icon: '🤖', title: 'Asistente IA', desc: 'Chat integrado' },
  { icon: '📊', title: 'Analytics', desc: '8 dashboards' },
  { icon: '💰', title: 'Pricing Dinámico', desc: 'Monitoreo 24/7' },
  { icon: '🚢', title: 'Importaciones', desc: 'Contenedores 3D' },
  { icon: '🔗', title: 'Integraciones', desc: 'SAP, Salesforce, Odoo' },
];

export const STATS = [
  { value: 16, suffix: '+', label: 'Modelos de Pricing' },
  { value: 24, suffix: '/7', label: 'Monitoreo' },
  { value: 30, suffix: '+', label: 'Herramientas IA' },
  { value: 99.9, suffix: '%', label: 'Uptime' },
];
